import { Helmet } from 'react-helmet-async';
import { SITE_ORIGIN, site } from '../content';

export default function Seo({ title, description, path, image, type = 'website', jsonLd }) {
  const canonical = `${SITE_ORIGIN}${path || '/'}`;
  const ogImage = image ? (image.startsWith('http') ? image : `${SITE_ORIGIN}${image}`) : `${SITE_ORIGIN}/assets/images/favicons/apple-touch-icon.png`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={site.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
